import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_IUB_PRIVACY_POLICY_URL;

interface PolicyResponse {
    policyHTML: string | null;
    loading: boolean;
    error: string | null;
}

export const useGetPolicyUrls = (policyId: number, privacyPolicy: boolean): PolicyResponse => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null)
    const [policyHTML, setPolicyHTML] = useState<string | null>(null)

    useEffect(() => {
        // console.log(`[useGetPolicyUrls] Hook attivato con policyId: ${policyId}, privacyPolicy: ${privacyPolicy}`);

        if (!policyId || typeof policyId !== 'number' || policyId <= 0) {
            // console.log("[useGetPolicyUrls] Uscita anticipata: policyId non valido.", policyId);
            setLoading(false);
            setError("ID Policy non valido fornito.");
            return;
        }


        const fetchPolicyDetails = async () => {
            setLoading(true);
            setError(null);
            setPolicyHTML(null); // Resetto l'HTML precedente all'inizio di un nuovo fetch

            // Determina l'URL completo
            const requestUrl = privacyPolicy
                ? `${API_BASE_URL}${policyId}` // Per Privacy Policy
                : `${API_BASE_URL}${policyId}/cookie-policy`; // Per Cookie Policy

            // Stampo l'URL che sta per essere richiesto
            console.log(`[useGetPolicyUrls] Invio richiesta GET a: ${requestUrl}`);
            // ---------------------------------

            try {
                const { data } = await axios.get(requestUrl);


                if (data && typeof data === 'object' && 'content' in data) {
                    setPolicyHTML(data.content);
                } else {
                    throw new Error("Risposta da Iubenda non contiene il campo 'content' atteso.");
                }
            } catch (err: any) {
                setError(err.message || 'Errore durante il recupero della policy da Iubenda.');
            } finally {
                setLoading(false);
            }
        };

        fetchPolicyDetails();

    // Aggiungo API_BASE_URL alle dipendenze se potesse cambiare (anche se da env di solito è costante per build)
    }, [policyId, privacyPolicy, API_BASE_URL]);

    return { loading, error, policyHTML };

};